import { render, staticRenderFns } from "./revenueAnalysis.vue?vue&type=template&id=521159da&scoped=true"
import script from "./revenueAnalysis.vue?vue&type=script&lang=js"
export * from "./revenueAnalysis.vue?vue&type=script&lang=js"
import style0 from "./revenueAnalysis.vue?vue&type=style&index=0&id=521159da&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521159da",
  null
  
)

export default component.exports